var site = site || {};
site.inits = [];
site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.hero = {};
site.search = {};
site.extras = {};
site.sidebar = {};
site.extras.isoFilters = ['', ''];
site.extras.initDone = false;

site.device.isTouch = function () {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function (id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.addClass('owl-carousel');
		$owl.owlCarousel(options);
	}
};


site.nav.submenuWidth = function () {
	/*var $submenu = $('.mmLevel2','#mainmenu');
	 var rt = (($('body').width() - $('.contentWrap', '#header').width()) / 2);
	 if ($('.contentWrap', '#header').width() >= 1145) {
	 rt = rt + 12.5;
	 }
	 $submenu.css('margin-right', rt*-1);*/

	var $submenu = $('.mmLevel2', '#mainmenu');
	var rt = (($('body').width() - $('.fbLikeBanner .contentWrap', '#footerInfo').width()) / 2);
	if (rt < 15) {
		rt = 15;
	}
	$submenu.css('margin-right', rt * -1);
};

$(window).resize(function () {
	site.nav.submenuWidth();
});

$(window).load(function () {
	site.nav.submenuWidth();
});

// Init navigation scripts
site.nav.init = function () {
	// Add expand link to mobile menu
	$('.children', '#mainmenu2 ').prepend('<a class="expand" href="#"><span class="fa fa-caret-down"></span></a>');

	$('.selectedLevel1.children, .selectedLevel2.children', '#mainmenu2').addClass('down');
	$('.selectedLevel1, .selectedLevel2, .selectedLevel3, .selectedLevel4', '#mainmenu2').find('> a.expand').addClass('down');
	$('.selectedLevel1, .selectedLevel2, .selectedLevel3, .selectedLevel4', '#mainmenu2').find('> ul.menu').addClass('down');

	site.nav.bind();
};

// Bind events
site.nav.bind = function () {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function (e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// Expand in mobile menu
	$('.expand', '#mainmenu2').bind('click', function (e) {
		e.preventDefault();

		var $this = $(this);
		var $ul = $this.siblings('ul');

		$this.parent().toggleClass('down');
		$ul.toggleClass('hide');
		$this.next().toggleClass('down');
		$this.toggleClass('down');
		e.preventDefault();
	});

	/*$('>a','#mainmenu .level1.children').on('click', function (e) {
	 if ($('body').width()+15 < 992 || $('body').hasClass('stillingar')) return;
	 if (!$('body').hasClass('submenu') || !$(this).parents('.selectedLevel1').length) {
	 e.preventDefault();
	 $('.level1','#mainmenu').removeClass('selectedLevel1');
	 $(this).parent().addClass('selectedLevel1');
	 $('body').addClass('submenu');
	 }

	 $('body.submenu').on('click', function (e) {
	 if (!$(e.target).parents('.mmLevel1').length) {
	 $('body').removeClass('submenu');
	 }
	 });
	 });*/


	$('li.level1.children > a', '#mainmenu').bind('click', function (e) {
		var $li = $(this).parents('li');

		if (!$li.hasClass('open') && !$('body').hasClass('mainmenu-open')) {
			e.preventDefault();
			site.nav.closeSubmenu();
			$li.addClass('open');
			$('body').addClass('submenu');

			$submenuHeight = $li.find('>.mmLevel2').height();
			$contentContainer = $('#contentContainer');
			if ($submenuHeight > $contentContainer.height()) {
				$contentContainer.css('min-height', $submenuHeight + 50);
			}
		}
		$('body.submenu').on('click', function (e) {
			if (!$(e.target).parents('.mmLevel1').length) {
				site.nav.closeSubmenu();
			}
		});
	});
};

site.nav.closeSubmenu = function () {
	$('body').removeClass('submenu');
	$('li.level1.children', '#mainmenu').removeClass('open');
};

// Toggle mobile menu
site.nav.mobileToggle = function (e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
	}
	else {
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function () {
	/*	var $divisions = $('.menu', '#divisions');
	 var $menu = $('ul.mmLevel1', '#mMenu');

	 var $html = $('<li class="ele-language si level1"></li>');
	 $divisions.find('li').each(function() {
	 var $li = $(this).clone();
	 $html.append($li.find('a'));
	 });

	 $menu.append($html);*/


	var $menu = $('ul.mmLevel1', '#mainmenu2');
	var $add = $('li.languages', '#qn').clone();
	$add.addClass('level1');
	$menu.append($add);

};


// Add main menu text
site.nav.appendSubText = function menuText() {
	$t = $('#menutext');
	$('#mainmenu').find('li.level1').not('.hidden-lg').not('.ele-um-fib').each(function (i) {
		$(this).append('<span class="text">' + $t.find('.box_ord_' + (i + 1) + ' .boxText').text() + '</span>');
	});
};


// Megamenu

site.megamenu = {
	init: function () {
		$('#mainmenu .level1.children').each(function () {
			var $this = $(this);
			var eleClass = $this.attr('class').split(' ')[0];
			var codename = eleClass.split('-').slice(1, eleClass.length).join('-');
			site.megamenu.loadImage(codename);
			$this.find('> .mmLevel2').prepend($this.find("> a").clone());
		});
	},
	loadImage: function (key) {
		var categories = {'thjonusta': '2', 'bilakaup': '5', 'ferdalog': '3', 'umferdaroryggi': '6'};


		var catId = categories[key];
		$.ajax({
			url: '/_/moya/adverts/region/show/2/' + catId,
			success: function (r) {
				$('.level1.ele-' + key + ' .mmLevel2', '#mainmenu').append('<div class="images">' + r + '</div>');
			}
		});
	}
};

site.search.init = function () {
	$qnav = $('#qnav');
	$searchDrop = $('#pageContainer .searchDrop');

	$qnav.find('.gler').click(function () {
		$('body').addClass('open-search');
		$searchDrop.removeClass('hide');
		$searchDrop.addClass('animated bounceInDown');
		$searchDrop.find('#q').focus();

	});

	$searchDrop.find('.glerClose').click(function () {
		site.search.closeSearch();
	});
};


site.search.closeSearch = function () {
	if ($('body').hasClass('open-search')) {
		$searchDrop = $('#pageContainer .searchDrop');

		$('body').removeClass('open-search');
		$searchDrop.removeClass('animated bounceInDown');
		$searchDrop.addClass('animated bounceOutUp');
		window.setTimeout(function () {
			$searchDrop.removeClass('animated bounceOutUp');
			$searchDrop.addClass('hide');
		}, 1000);
	}
};

// Prepend search to mobile menu
site.nav.prependSearch = function () {
	var $searchForm = $('#searchForm');
	var $menu = $('ul.mmLevel1', '#mainmenu2');

	$menu.prepend($searchForm.clone().wrap("<li class='search'></div>").parent());
};

site.extras = {
	init: function() {
		site.extras.initFilter();
		site.extras.filterDropDown();
	},

	initFilter: function() {
		activeFilters = {},

		getComboFilter = function () {
			var combo = [];
			for (var prop in activeFilters) {
				var group = activeFilters[prop];
				if (!group.length) {
					continue;
				}
				if (!combo.length) {
					combo = group.slice(0);
					continue;
				}
				var nextCombo = [];
				// splitta hópum í combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
				for (var i = 0; i < combo.length; i++) {
					for (var j = 0; j < group.length; j++) {
						var item = combo[i] + group[j];
						nextCombo.push(item);
					}
				}
				combo = nextCombo;
			}
			var comboFilter = combo.join(', ');
			return comboFilter;
		},
		addActiveFilter = function(group, filter) {
			var filterGroup = activeFilters[ group ];
			if ( !filterGroup ) {
				filterGroup = activeFilters[ group ] = [];
			}
			filterGroup.push(filter);
		},
		removeActiveFilter = function(group, filter) {
			var filterGroup = activeFilters[ group ];
			if ( !filterGroup ) {
				filterGroup = activeFilters[ group ] = [];
			}
			var index = filterGroup.indexOf( filter );
			filterGroup.splice( index, 1 );
		};

		var $grid = $('#extras .items').isotope({
			itemSelector: '.item',
			layoutMode: 'vertical',
			hiddenStyle: {
				opacity: 0
			},
			visibleStyle: {
				opacity: 1
			},
			filter: function () {
				var $this = $(this);
				var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
				var buttonResult = getComboFilter() ? $this.is(getComboFilter()) : true;
				return searchResult && buttonResult;
			},
			soryBy: 'name'
		});

		$('.itemFilter').on('click', 'a', function(e) {
			e.preventDefault();
			var $this = $(this);
			var filterValue = '.' + $this.attr('href').slice(1);

			if ($this.hasClass('all')) {
				if (!$this.hasClass('selected')) {
					$this.siblings().each(function() {
						var $sibling = $(this);
						$sibling.removeClass('selected');
						if($(this).hasClass('single')) {
							removeActiveFilter('single', filterValue);
						}
						else {
							removeActiveFilter('many', filterValue);
						}
					});
					$this.addClass('selected');
				}
			}
			else {
				$(this).closest('div').find('.all').removeClass('selected');

				if (!$this.hasClass('selected')) {
					$this.addClass('selected');
					if ($this.hasClass('single')) {
						addActiveFilter('single', filterValue);
					}
					else {
						addActiveFilter('many', filterValue);
					}
				}
				else {
					$this.removeClass('selected');
					if($(this).hasClass('single')) {
						removeActiveFilter('single', filterValue);
					}
					else {
						removeActiveFilter('many', filterValue);
					}
				}
			}
			$this.blur();
			$grid.isotope();
		});
		$('.item', '#extras .items').on('click', function (e) {
			$(this).toggleClass('open');
			$grid.isotope('layout');
			window.dispatchEvent(new Event('resize'));
		});

		$('.item a', "#extras .items").on('click', function (e) {
			e.stopPropagation();
		});

		var qsRegex;
		var $quicksearch = $('#extras input').keyup( debounce( function() {
			qsRegex = new RegExp( $quicksearch.val(), 'gi' );
			$grid.isotope();
		}, 200 ) );

		function debounce( fn, threshold ) {
			var timeout;
			threshold = threshold || 100;
			return function debounced() {
				clearTimeout( timeout );
				var args = arguments;
				var _this = this;
				function delayed() {
					fn.apply( _this, args );
				}
				timeout = setTimeout( delayed, threshold );
			};
		}
	},
	filterDropDown: function () {
		$('body').on('click', '#extras .itemFilter >.label', function (e) {
			e.preventDefault();
			$('body').toggleClass('filter-open-first');

			var $parent = $(this).parent('.itemFilter');
			$parent.toggleClass('open').find('.wrap').toggleClass('open');

			$('body.filter-open-first').on('click', function (e) {
				if($(e.target).parents('.itemFilter').index() !== $parent.index()) {
					$('body').removeClass('filter-open-first');
					$parent.removeClass('open').find('.wrap').removeClass('open');
				}
			});

		});
	}
};

site.sidebar.init = function () {
	$('.eldsneyti', "#sidebar2").bind('click', function (e) {
		e.preventDefault();

		if ($('#sidebar2').hasClass('open') && !($(this).hasClass('down'))) {
			site.sidebar.closeSidebar();
			window.setTimeout(function () {
				$('.btn.eldsneyti', '#sidebar2 .takkar').addClass('down');
				$('#sidebar2').addClass('open');
				$('.box_ord_2', '#sidebar2').addClass('open');
			}, 400);
		} else if ($('#sidebar2').hasClass('open')) {
			site.sidebar.closeSidebar();
		} else {
			$(this).addClass('down');
			$('#sidebar2').addClass('open');
			$('.box_ord_2', '#sidebar2').addClass('open');
		}

	});

	$('.medlimur', "#sidebar2").bind('click', function (e) {
		e.preventDefault();

		if ($('#sidebar2').hasClass('open') && !($(this).hasClass('down'))) {
			site.sidebar.closeSidebar();

			window.setTimeout(function () {
				$('.btn.medlimur', '#sidebar2 .takkar').addClass('down');
				$('#sidebar2').addClass('open');
				$('.box_ord_1', '#sidebar2').addClass('open');
			}, 400);
		} else if ($('#sidebar2').hasClass('open')) {
			site.sidebar.closeSidebar();
		} else {
			$(this).addClass('down');
			$('#sidebar2').addClass('open');
			$('.box_ord_1', '#sidebar2').addClass('open');
		}

	});
};

site.sidebar.closeSidebar = function () {
	$('#sidebar2').removeClass('open');
	$('.btn', '#sidebar2 .takkar').removeClass('down');
	$('> .box', '#sidebar2').removeClass('open');
};

site.extras.updateFilter = function () {
	site.extras.isoFilters[0] = $('#extrasCategoryLandshlutar', "#extras").val();
	site.extras.isoFilters[1] = $('#extrasCategory', "#extras").val();
	location.hash = site.extras.isoFilters.join('&');
	$('.items', '#extras').isotope({filter: site.extras.isoFilters.join('').replace('*', '')});
};

site.extras.upload = {
	init: function (urls, lang) {
		if (site.extras.initDone === false) {
			site.extras.initDone = true;
			$('ul#images').sortable({
				'opacity': 0.8,
				'update': function (e, ui) {
					var $el = $(this);
					$el.sortable('disable').addClass('disabled');
					$.post(urls.sort, $(this).sortable('serialize'), function (d) {
						if (d.success !== true) {
							moya.message.add(lang.galleryErrorOnSave);
							$el.sortable('cancel');
						}
						$el.removeClass('disabled');
						$el.sortable('enable');
					});
				}
			});
			$('#ffile').uploadify({
				'uploader': '/_moya/js/jquery/uploadify/uploadify.swf',
				'script': urls.script,
				'cancelImg': '/_moya/js/jquery/uploadify/cancel.png',
				'auto': true,
				'multi': true,
				'folder': '/tmp',
				'fileDesc': lang.galleryImageUploadFileDescription,
				'fileExt': '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG',
				'buttonText': lang.galleryImageAdd,
				'queueID': 'ffileQueue',
				'onError': function () {
					$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
				},
				'onComplete': function (e, q, f, r) {
					var n = $('#notice');
					switch (r) {
						case 'noAlbum':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
							break;
						case 'noSave':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
							break;
					}
				},
				'onAllComplete': function () {
					window.location.reload();
				}
			});
		}
	}
};

site.store = {
	init: function () {
		var $body = $('body');
		$body.on('click', '#storeCart .showMore', function (e) {
			if (!$(this).hasClass('empty')) {
				e.preventDefault();
				$('body').toggleClass('cart-open');

				$('body.cart-open').on('click', function (e) {
					if (!$(e.target).parents('#storeCart').length) {
						$('body').removeClass('cart-open');
					}
				});
			}
		});

		//Checkout
		if ($body.hasClass('checkout')) {
			$('#billing-billingSameAsShipping').change(function() {
				var $fieldset = $('#fieldset-billing').toggleClass('disabled');
				if ($fieldset.hasClass('disabled')) {
					$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
				}
				else {
					$fieldset.find('input:not(.checkbox)').attr('disabled', null);
				}
			}).change();

			$('ul.paymentTypeSelection li').click(function(){
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
			});
		}
	}
};

site.inits.push('site.store.init()');

store = window.store || {};
store.local = store.local || {};
store.local.onUpdateVariantData = function(variant) {
	var attributes = '';
	$.each(variant.attributes, function(attrIdx, attr) {
		attributes += attr + ' / ';
	});
	attributes = attributes.substr(0, attributes.length - 3);

	$('.product .attributes').html(attributes);
};

store.local.updateMiniCart = function() {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$('.cartBoxMedium').replaceWith(data.html);
	}, 'json');
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function() {
	store.local.updateMiniCart();
};

store.local.onCartIncrease = function() {
	store.local.updateMiniCart();
};

store.local.onCartDecrease = function() {
	store.local.updateMiniCart();
};

store.local.initAlbumImages = function() {
	site.owl.init('.product .albumImages', {
		loop: false,
		dots: false,
		nav: false,
		items: 4,
		navText: ["", ""],
		margin: 30,
		responsive: {
			0: {
				items: 2
			},
			480: {
				items: 4
			}
		}
	});

	var $albumLink = $('ul.albumImages a');
	$albumLink.removeClass('fancybox');
	$albumLink.click(function (e) {
		e.preventDefault();
		$this = $(this);
		$albumLink.parent().removeClass('selected');
		$this.parent().addClass('selected');
		$href = $this.attr('href');
		$src = $this.find('img').attr('src');
		$label = $this.find('img').attr('alt');
		$image = $('.images .image');

		if ($src != $('img', $image).attr('src')) {
			$image.append('<div class="loading">')
			$image.find('.caption').text($label);
			$('img', $image).attr("src", $src).load(function () {
				$('.loading', $image).remove();
			});
		}
	});

	$(window).load(function () {
		$('.attribute select').wrapAll('<span class="lmnt" />');
	});
};

// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.nav.init();
	site.nav.appendSubText();
	site.nav.appendLanguage();
	site.search.init();
	site.megamenu.init();
	site.nav.prependSearch();
	site.sidebar.init();
	$('img.responsive').responsiveImg();

	if ($('#hero li').length > 1) {
		site.owl.init('#hero > ul', {
			loop: true,
			dots: true,
			autoplay: true,
			autoplayTimeout: 8000,
			autoplayHoverPause: true,
			stopOnHover: true,
			navText: ["", ""],
			dotsSpeed: 500,
			autoplaySpeed: 500,
			dragEndSpeed: 500,
			items: 1,
			onDrag: function () {
				$('#hero .owl-controls').hide();
			},
			onDragged: function () {
				$('#hero .owl-controls').show();
			}
		});
	}

	$('li.dropdown > a').click(function (e) {
		e.preventDefault();
	});

	$(document).mouseup(function (e) {
		var container = $('.searchDrop');
		var c2 = $('.searchDrop').find('*');
		if (!container.is(e.target) && !c2.is(e.target)) {
			site.search.closeSearch();
		}

		var sideContainer = $('#sidebar2');
		var sideElements = sideContainer.find('*');
		if (!sideContainer.is(e.target) && !sideElements.is(e.target)) {
			site.sidebar.closeSidebar();
		}
	});

	//$('iframe').height( $('iframe').contents('body').outerHeight());

	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	$('table', '#main').wrap('<div class="table-responsive"></div>');

	// Responsive content images
	$('.entryContent img:not(.responsive)').each(function () {
		$(this).addClass('responsive').addClass('loaded');
	});

	// Touch login
	$('.login').bind('click', function (e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);
});

function scrollClass(minScroll, fClass) {
	var scrollTop = $(window).scrollTop();
	site.nav.closeSubmenu();
	if (scrollTop > minScroll) {
		$('body').addClass(fClass);
	} else {
		$('body').removeClass(fClass);
	}
}

var timer;
$(window).scroll(function () {
	/*if(timer) {
	 window.clearTimeout(timer);
	 }*/

	//timer = window.setTimeout(function() {
	var body = $('body');

	scrollClass(86 - 25, 'stickyHead');
	scrollClass(80, 'stickyHead2');
	//}, 10);
});
